define('webshopProductsCategoriesListFiltersEditView',[
  'module',
  'underscore',
  'checkboxView',
  'webshopProductsFinderListFiltersEditView',
  'template!webshopProductsCategoriesListFiltersEditView'
], function (
  Module,
  _,
  CheckboxView,
  FinderEditView,
  Tpl
) {
  'use strict';

  Module.exports = FinderEditView.extend({
    template: Tpl,
    className: 'webshop-products-categories-list-filters-edit-view ' + FinderEditView.prototype.className,
    windowTitle: _.i18n('webshop.products.categories.filters.edit.title', null, 'Filters'),

    regions: _.extend({
      noCategoryRegion: '.no-category .checkbox-region'
    }, FinderEditView.prototype.regions),

    onShow: function () {
      this.noCategoryView = new CheckboxView({
        title: '',
        text: _.i18n('webshop.products.categories.filters.noCategory', null, 'Products without any category'),
        value: this.model.get('noCategory') === '1',
        tabindex: 9
      });
      this.getRegion('noCategoryRegion').show(this.noCategoryView);

      FinderEditView.prototype.onShow.apply(this, arguments);
    },

    onConfirm: function () {
      this.model.set('noCategory', this.noCategoryView.getValue() ? '1' : '');

      FinderEditView.prototype.onConfirm.apply(this, arguments);
    },

    onReset: function () {
      this.noCategoryView.setValue(false);

      FinderEditView.prototype.onReset.apply(this, arguments);
    }
  });
});

